import fetch from '../utils/fetch'

// 获取售后原因列表
export function aftersalesSettingReason(params){
  return fetch({
    url: '/aftersales/setting/reason/list',
    method: 'get',
    params: params
  })
}
